import { EnumOption } from "./enum-option"

export const TaskType = {
    Document: 0,
    ToDo: 1,
    WorkflowStep: 2
}

export const TaskTypeList: EnumOption[] = [
    { value: TaskType.Document, label: 'Document' },
    { value: TaskType.ToDo, label: 'To-Do' },
    { value: TaskType.WorkflowStep, label: 'Workflow Step' }
]
